import { pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core';

import { atsProviderEnum } from './ats-configs';

import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const candidates = pgTable(
  'candidates',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    name: text('name').notNull(),
    email: text('email').notNull(),
    phoneNumber: text('phone_number'),
    phoneCountryCode: text('phone_country_code'),
    atsExternalCandidateId: text('ats_external_candidate_id'),
    atsProvider: atsProviderEnum('ats_provider'),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [
    unique('candidates_tenant_org_email').on(t.tenantId, t.orgId, t.email),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
